import { cn } from "@/shared/lib/utils"

interface IkonSvgProps {
  svg: string
  warna?: string
  className?: string
}

export function IkonSvg({ svg, warna, className = "w-5 h-5" }: IkonSvgProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-flex shrink-0 [&>svg]:h-full [&>svg]:w-full", className)}
      style={warna ? { color: warna } : undefined}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
